import React, { Component } from "react"
import Button from "components/common/Button"
import LazyLoadWrapper from "components/common/LazyLoadWrapper"

import ImagePlaceholder from "assets/images/imageplaceholder.png"

import "styles/components/common/progress-card.scss"

class ProgressCard extends Component {
  handleViewCourse = (course = {}) => {
    try {
      const token = localStorage.getItem("token")
      const courseURL = new URL(`${course.course_detail_link}`)

      const queryParams = new URLSearchParams({
        redirect: course?.course_detail_link?.replace("https://", ""),
      })

      const redirectURL = `https://${
        courseURL.host
      }/auth/${token}?${queryParams.toString()}`

      window.open(redirectURL, "_blank")
    } catch (error) {
      console.error(error)
    }
  }

  renderProgressLabel(progress) {
    if (progress === 0) {
      return <span className="progress-label">Not Started</span>
    } else if (progress > 0 && progress < 100) {
      return <span className="progress-label">In Progress</span>
    } else if (progress === 100) {
      return <span className="progress-label">Completed</span>
    } else {
      return <span className="progress-label">In Progress</span>
    }
  }

  render() {
    const {
      data: { progress, course },
    } = this.props

    return (
      <div className="progress-card">
        <div className="card-image">
          <LazyLoadWrapper
            onError={(e) => (e.target.src = ImagePlaceholder)}
            src={`${course.image}`}
            effect="blur"
            height="100%"
            width="100%"
            display="block"
          />
        </div>
        <div className="card-content">
          <h2 className="card-subtitle">{course.school_name}</h2>
          <h2 className="card-title">{course.name}</h2>
          <div className="card-description">
            <progress value={progress} max="100" />
            <div className="card-progress">
              {this.renderProgressLabel(progress)}
              <span className="progress-status">{progress}%</span>
            </div>
            <div className="card-foot">
              <span className="course-category">{course.category}</span>
              <Button
                label="View Course"
                size="small"
                onClick={() => this.handleViewCourse(course)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressCard
